import { render, staticRenderFns } from "./car-call.vue?vue&type=template&id=46071680"
import script from "./car-call.vue?vue&type=script&lang=js"
export * from "./car-call.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonAutoteka: require('/var/www/components/button/button-autoteka.vue').default,ButtonFavorite: require('/var/www/components/button/button-favorite.vue').default,ButtonCall: require('/var/www/components/button/button-call.vue').default})
